import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Button = styled.div`
  width: 24px;
  height: 20px;
  position: absolute;
  top: 32px;
  right: 25px;
  cursor: pointer;
  z-index: 10;
  transition: opacity 0.3s ease-out;

  span {
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 2px;
    background-color: #fff;
    transition: all 0.3s ease;
    border-radius: 1px;

    &:first-child {
      transform: translate(0px, 0px);
    }

    &:nth-child(2) {
      transform: translate(0px, 8px);
    }

    &:last-child {
      position: absolute;
      top: 0;
      right: 0;
      left: auto;
      transform: translate(0px, 16px);
    }
  }

  &.toggled {
    position: fixed;

    span {
      width: 100%;

      &:first-child {
        transform: rotate(45deg) translate(6px, 6px);
      }

      &:nth-child(2) {
        opacity: 0;
      }

      &:last-child {
        transform: translate(0px, 9px) rotate(-45deg);
      }
    }
  }
`

const MenuButton = ({ toggled, onClick, style }) => (
  <Button
    onClick={onClick}
    className={toggled ? 'menu-button toggled' : 'menu-button'}
    style={style}
  >
    <span></span>
    <span></span>
    <span></span>
  </Button>
)

MenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  toggled: PropTypes.bool.isRequired,
}

export default MenuButton



// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/MenuButton.js